/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/kycform.config.json";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_OFFER_DATA } from "../graphql";
import { VApplication } from "../../../application";

import { StorageModule } from "@vlinder-web/storage-module-react";

export interface IOfferDataMethods extends IPluginMethodMap {
  getOfferDataContent(args: any): any;
}

const lookup = require("country-code-lookup");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class OfferDataService implements IAgentPlugin {
  readonly methods: IOfferDataMethods;
  constructor() {
    this.methods = {
      getOfferDataContent: this.getProps.bind(this),
    };
  }
  async getProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const storageSrv = StorageModule.getInstance();
    try {
      if (client) {
        const res = await client.query({
          query: GET_OFFER_DATA,
          variables: {
            input: {
              countryName: args,
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data?.checkOfferIsApplicable) {
          let _res = res?.data?.checkOfferIsApplicable;
          // _res.discountPercent = 25
          return _res;
        }
      }
    } catch (err: any) {
      console.log(`offer Date Error`, err?.response?.data);
      throw Error(err?.response?.data?.error?.display_message);
    }

    // return {
    //     isOffer:true,
    //     description:"Upto 20% off Hurry up!"
    // }
  }
}
